import React from 'react';
import { FeatureDataContextType } from './types';

export const FeatureDataContext = React.createContext<
  FeatureDataContextType<unknown> | undefined
>(undefined);
